import React from 'react';
import Nodata from '../../shared-components/no-data-svg/no-data-svg';
import { FormattedMessage } from 'react-intl';
import RoutesConstants from '../../constants/routes.constant';
import { useHistory } from 'react-router-dom';

const InvalidStore = () => {

  const history = useHistory(); 
  const goBackToLogin = () => { 
      history.push(RoutesConstants.StoreListPage);
    };
  return (
    <>
      <div className='text-center h-100 d-flex flex-column justify-content-center align-items-center'>
        <Nodata />
        <h1>
            <FormattedMessage id="invalid_store_message" />
        </h1>
        <button className='btn btn-primary mt-3' onClick={() => {
                        goBackToLogin();
                      }}>
            <FormattedMessage id="back_to_store_list" />
        </button>
      </div>
    </>
  );
};

// export default injectIntl(InvalidStore);
export default InvalidStore;
